export const SMART_SEARCH_JOB_KEYWORDS: readonly string[] = [
  'orthodontist',
'specialist orthodontist',
'orthodontic specialist',
'dentist',
'dental surgeon',
'general practitioner',
'pediatric dentist',
'pediatric dentistry',
'orthodontics',

'أخصائي تقويم أسنان',
'اخصائي تقويم اسنان',
'تقويم أسنان',
'تقويم اسنان',
'طبيب أسنان',
'طبيب اسنان',
'جراح أسنان',
'جراح اسنان',
    // =========================
  // Medical / Healthcare / Clinics - English
  // =========================
  'medical doctor',
  'doctor',
  'physician',
  'general physician',
  'general practitioner',
  'gp doctor',
  'resident doctor',
  'specialist doctor',
  'consultant doctor',
  'medical consultant',
  'medical specialist',
  'clinic doctor',
  'hospital doctor',
  'house officer',
  'intern doctor',
  'medical intern',
  'medical officer',
  'healthcare officer',
  'healthcare specialist',
  'healthcare consultant',
  'healthcare manager',
  'clinic manager',
  'medical director',
  'clinical director',

  'dermatologist',
  'aesthetic dermatologist',
  'cosmetic dermatologist',
  'dermatology specialist',
  'dermatology resident',
  'dermatology consultant',
  'dermatology doctor',
  'skin doctor',
  'skin specialist',
  'laser specialist',
  'laser doctor',
  'aesthetic doctor',
  'aesthetic physician',
  'aesthetic specialist',
  'cosmetic doctor',
  'venereologist',
  'dermatology and venereology',
  'dermatology venereology',
  'aesthetic medicine doctor',
  'cosmetology specialist',
  'cosmetic medicine specialist',

  'dentist',
  'general dentist',
  'dental doctor',
  'dental specialist',
  'dental consultant',
  'orthodontist',
  'periodontist',
  'prosthodontist',
  'endodontist',
  'oral surgeon',
  'implantologist',
  'pediatric dentist',
  'dental assistant',
  'dental nurse',
  'dental technician',
  'dental hygienist',

  'pharmacist',
  'clinical pharmacist',
  'community pharmacist',
  'hospital pharmacist',
  'retail pharmacist',
  'assistant pharmacist',
  'pharmacy manager',
  'pharmacy assistant',
  'pharmacy technician',
  'drug specialist',
  'regulatory affairs specialist',
  'medical affairs specialist',
  'pharmacovigilance specialist',

  'nurse',
  'registered nurse',
  'staff nurse',
  'head nurse',
  'charge nurse',
  'icu nurse',
  'er nurse',
  'emergency nurse',
  'operation nurse',
  'operating room nurse',
  'scrub nurse',
  'pediatric nurse',
  'dental nurse',
  'clinic nurse',
  'home care nurse',
  'nursing supervisor',
  'nursing manager',
  'nursing assistant',
  'caregiver',
  'healthcare assistant',

  'surgeon',
  'general surgeon',
  'plastic surgeon',
  'orthopedic surgeon',
  'cardiothoracic surgeon',
  'vascular surgeon',
  'neurosurgeon',
  'urologist',
  'ent specialist',
  'ear nose throat specialist',
  'ophthalmologist',
  'eye doctor',
  'optometrist',
  'cardiologist',
  'heart specialist',
  'neurologist',
  'psychiatrist',
  'psychologist',
  'clinical psychologist',
  'pediatrician',
  'gynecologist',
  'obstetrician',
  'obgyn doctor',
  'internal medicine doctor',
  'internist',
  'gastroenterologist',
  'hepatologist',
  'nephrologist',
  'pulmonologist',
  'chest doctor',
  'endocrinologist',
  'diabetologist',
  'rheumatologist',
  'oncologist',
  'hematologist',
  'radiologist',
  'anesthesiologist',
  'emergency medicine doctor',
  'family medicine doctor',
  'occupational medicine doctor',
  'public health doctor',
  'infection control doctor',

  'physiotherapist',
  'physical therapist',
  'rehabilitation specialist',
  'sports therapist',
  'occupational therapist',
  'speech therapist',
  'speech language therapist',
  'nutritionist',
  'clinical nutritionist',
  'dietitian',
  'clinical dietitian',

  'lab technician',
  'laboratory technician',
  'medical laboratory technician',
  'lab specialist',
  'laboratory specialist',
  'medical lab specialist',
  'pathology specialist',
  'microbiology specialist',
  'chemistry specialist',
  'blood bank specialist',
  'radiology technician',
  'radiology specialist',
  'x ray technician',
  'ct technician',
  'mri technician',
  'ultrasound specialist',
  'sonographer',
  'ecg technician',
  'dialysis technician',
  'sterilization technician',
  'cssd technician',
  'anesthesia technician',
  'operation technician',
  'medical technician',
  'biomedical engineer',
  'medical equipment engineer',

  'medical representative',
  'medical rep',
  'medical sales representative',
  'pharmaceutical sales representative',
  'product specialist',
  'medical product specialist',
  'medical sales specialist',
  'medical sales executive',
  'healthcare sales',
  'healthcare sales specialist',
  'medical device sales',
  'medical device specialist',
  'clinical application specialist',
  'application specialist',
  'product manager healthcare',
  'product manager pharmaceutical',

  'veterinarian',
  'veterinary doctor',
  'vet doctor',
  'vet',
  'veterinary specialist',
  'veterinary consultant',
  'veterinary assistant',
  'vet assistant',
  'animal doctor',
  'pet doctor',
  'pet care specialist',
  'grooming doctor',
  'veterinary pharmacist',
  'veterinary sales representative',

  'medical receptionist',
  'clinic receptionist',
  'hospital receptionist',
  'patient coordinator',
  'patient relation officer',
  'patient relations specialist',
  'patient experience specialist',
  'medical coordinator',
  'clinic coordinator',
  'insurance coordinator',
  'medical insurance specialist',
  'claims specialist',
  'medical claims officer',
  'medical coder',
  'medical billing specialist',
  'medical records officer',
  'medical records specialist',
  'health information specialist',
  'quality healthcare specialist',
  'infection control specialist',
  'hse healthcare specialist',

  'beauty therapist',
  'laser technician',
  'aesthetic nurse',
  'aesthetic therapist',
  'skin therapist',
  'cosmetic therapist',
  'cosmetologist',
  'beautician',
  'spa therapist',
  'derma therapist',

  // =========================
  // Medical / Healthcare / Clinics - Arabic
  // =========================
  'طبيب',
  'دكتور',
  'طبيبة',
  'دكتورة',
  'طبيب عام',
  'طبيبة عامة',
  'طبيب مقيم',
  'طبيبة مقيمة',
  'طبيب اخصائي',
  'طبيب أخصائي',
  'طبيبة اخصائية',
  'طبيبة أخصائية',
  'استشاري طبي',
  'استشاري',
  'استشارية',
  'طبيب استشاري',
  'طبيبة استشارية',
  'مدير طبي',
  'مدير عيادة',
  'مدير مستشفى',
  'مسؤول طبي',
  'اخصائي رعاية صحية',
  'أخصائي رعاية صحية',

  'جلدية',
  'طبيب جلدية',
  'طبيبة جلدية',
  'اخصائي جلدية',
  'أخصائي جلدية',
  'إخصائي جلدية',
  'اخصائية جلدية',
  'أخصائية جلدية',
  'استشاري جلدية',
  'استشارية جلدية',
  'جلدية وتناسلية',
  'أمراض جلدية وتناسلية',
  'امراض جلدية وتناسلية',
  'دكتور جلدية',
  'دكتورة جلدية',
  'طبيب تجميل',
  'طبيبة تجميل',
  'اخصائي تجميل',
  'أخصائي تجميل',
  'اخصائية تجميل',
  'أخصائية تجميل',
  'تجميل وليزر',
  'اخصائي ليزر',
  'أخصائي ليزر',
  'اخصائية ليزر',
  'أخصائية ليزر',
  'طبيب ليزر',
  'طبيبة ليزر',
  'اخصائي بشرة',
  'أخصائي بشرة',
  'اخصائية بشرة',
  'أخصائية بشرة',
  'طب تجميلي',
  'طب التجميل',
  'الجلدية والتناسلية',

  'طبيب أسنان',
  'طبيب اسنان',
  'طبيبة أسنان',
  'طبيبة اسنان',
  'دكتور اسنان',
  'دكتور أسنان',
  'دكتورة اسنان',
  'دكتورة أسنان',
  'اخصائي اسنان',
  'أخصائي أسنان',
  'اخصائية اسنان',
  'أخصائية أسنان',
  'استشاري اسنان',
  'استشاري أسنان',
  'تقويم اسنان',
  'تقويم أسنان',
  'جراحة فم وأسنان',
  'جراحة فم واسنان',
  'زراعة اسنان',
  'زراعة أسنان',
  'مساعد طبيب اسنان',
  'مساعد طبيب أسنان',
  'ممرضة اسنان',
  'ممرضة أسنان',
  'فني اسنان',
  'فني أسنان',

  'صيدلي',
  'صيدلاني',
  'صيدلانية',
  'دكتور صيدلي',
  'دكتورة صيدلية',
  'صيدلي اكلينيكي',
  'صيدلي إكلينيكي',
  'صيدلاني اكلينيكي',
  'صيدلانية اكلينيكية',
  'صيدلي مستشفى',
  'صيدلي مجتمع',
  'مدير صيدلية',
  'مساعد صيدلي',
  'فني صيدلة',
  'تيكنيكال صيدلة',
  'يقظة دوائية',
  'شؤون تنظيمية',
  'اخصائي شؤون تنظيمية',
  'أخصائي شؤون تنظيمية',

  'ممرض',
  'ممرضة',
  'تمريض',
  'اخصائي تمريض',
  'أخصائي تمريض',
  'مشرف تمريض',
  'مشرفة تمريض',
  'رئيس تمريض',
  'رئيسة تمريض',
  'ممرض عناية مركزة',
  'ممرضة عناية مركزة',
  'ممرض طوارئ',
  'ممرضة طوارئ',
  'ممرض عمليات',
  'ممرضة عمليات',
  'مساعد تمريض',
  'رعاية منزلية',
  'مقدم رعاية',
  'مقدمة رعاية',

  'جراح',
  'طبيب جراحة',
  'طبيبة جراحة',
  'جراحة عامة',
  'جراح عام',
  'جراحة تجميل',
  'جراح تجميل',
  'عظام',
  'طبيب عظام',
  'طبيبة عظام',
  'مخ واعصاب',
  'مخ وأعصاب',
  'طبيب مخ واعصاب',
  'طبيب مخ وأعصاب',
  'مسالك بولية',
  'طبيب مسالك بولية',
  'انف واذن وحنجرة',
  'أنف وأذن وحنجرة',
  'رمد',
  'طبيب عيون',
  'طبيبة عيون',
  'قلب',
  'طبيب قلب',
  'طبيبة قلب',
  'مخ واعصاب',
  'طبيب اعصاب',
  'طبيب أعصاب',
  'طبيب نفسي',
  'طبيبة نفسية',
  'اخصائي نفسي',
  'أخصائي نفسي',
  'اخصائية نفسية',
  'أخصائية نفسية',
  'اطفال',
  'أطفال',
  'طبيب اطفال',
  'طبيب أطفال',
  'نساء وتوليد',
  'طبيب نساء وتوليد',
  'باطنة',
  'طبيب باطنة',
  'جهاز هضمي',
  'كبد',
  'كلى',
  'صدر',
  'طبيب صدر',
  'غدد صماء',
  'سكر وغدد',
  'روماتيزم',
  'اورام',
  'أورام',
  'امراض دم',
  'أمراض دم',
  'اشعة',
  'أشعة',
  'طبيب اشعة',
  'طبيب أشعة',
  'تخدير',
  'طبيب تخدير',
  'طوارئ',
  'طبيب طوارئ',
  'طب اسرة',
  'طب أسرة',
  'صحة عامة',
  'مكافحة عدوى',
  'اخصائي مكافحة عدوى',
  'أخصائي مكافحة عدوى',

  'علاج طبيعي',
  'اخصائي علاج طبيعي',
  'أخصائي علاج طبيعي',
  'اخصائية علاج طبيعي',
  'أخصائية علاج طبيعي',
  'علاج وظيفي',
  'اخصائي تخاطب',
  'أخصائي تخاطب',
  'اخصائية تخاطب',
  'أخصائية تخاطب',
  'تغذية',
  'اخصائي تغذية',
  'أخصائي تغذية',
  'اخصائية تغذية',
  'أخصائية تغذية',
  'تغذية علاجية',
  'اخصائي تغذية علاجية',
  'أخصائي تغذية علاجية',

  'فني معمل',
  'فني مختبر',
  'اخصائي معمل',
  'أخصائي معمل',
  'اخصائي مختبر',
  'أخصائي مختبر',
  'اخصائي تحاليل',
  'أخصائي تحاليل',
  'تحاليل طبية',
  'فني تحاليل',
  'باثولوجي',
  'ميكروبيولوجي',
  'بنك دم',
  'فني اشعة',
  'فني أشعة',
  'اخصائي اشعة',
  'أخصائي أشعة',
  'فني رنين',
  'فني مقطعية',
  'فني موجات صوتية',
  'سونار',
  'فني رسم قلب',
  'فني غسيل كلوي',
  'فني تعقيم',
  'فني عمليات',
  'فني تخدير',
  'فني طبي',
  'مهندس اجهزة طبية',
  'مهندس أجهزة طبية',
  'مهندس طبي',
  'هندسة طبية',

  'مندوب طبي',
  'مندوبة طبية',
  'مندوب دعاية طبية',
  'مندوبة دعاية طبية',
  'مندوب ادوية',
  'مندوب أدوية',
  'مندوب مبيعات طبية',
  'مندوبة مبيعات طبية',
  'اخصائي مبيعات طبية',
  'أخصائي مبيعات طبية',
  'مبيعات اجهزة طبية',
  'مبيعات أجهزة طبية',
  'اخصائي اجهزة طبية',
  'أخصائي أجهزة طبية',
  'اخصائي منتجات طبية',
  'أخصائي منتجات طبية',
  'اخصائي تطبيقات طبية',
  'أخصائي تطبيقات طبية',

  'بيطري',
  'طبيب بيطري',
  'طبيبة بيطرية',
  'دكتور بيطري',
  'دكتورة بيطرية',
  'اخصائي بيطري',
  'أخصائي بيطري',
  'استشاري بيطري',
  'مساعد بيطري',
  'صيدلي بيطري',
  'مندوب بيطري',
  'رعاية حيوانات',
  'رعاية حيوان',
  'رعاية حيوانات أليفة',
  'رعاية حيوانات اليفة',
  'اخصائي رعاية حيوانات',
  'أخصائي رعاية حيوانات',

  'استقبال طبي',
  'موظف استقبال طبي',
  'موظفة استقبال طبي',
  'استقبال عيادة',
  'موظف استقبال عيادة',
  'منسق عيادة',
  'منسقة عيادة',
  'منسق مرضى',
  'منسقة مرضى',
  'علاقات مرضى',
  'مسؤول علاقات مرضى',
  'اخصائي علاقات مرضى',
  'أخصائي علاقات مرضى',
  'تأمين طبي',
  'تامين طبي',
  'اخصائي تأمين طبي',
  'أخصائي تأمين طبي',
  'مطالبات طبية',
  'اخصائي مطالبات طبية',
  'أخصائي مطالبات طبية',
  'ترميز طبي',
  'مكود طبي',
  'سجلات طبية',
  'مسؤول سجلات طبية',
  'اخصائي سجلات طبية',
  'أخصائي سجلات طبية',
  'جودة طبية',
  'جودة صحية',
  'اخصائي جودة طبية',
  'أخصائي جودة طبية',

  'بيوتي ثيرابيست',
  'اخصائي ليزر وتجميل',
  'أخصائي ليزر وتجميل',
  'اخصائية ليزر وتجميل',
  'أخصائية ليزر وتجميل',
  'فني ليزر',
  'فنية ليزر',
  'اخصائي عناية بالبشرة',
  'أخصائي عناية بالبشرة',
  'اخصائية عناية بالبشرة',
  'أخصائية عناية بالبشرة',
  'كوزمتولوجي',
  'كوزمتولوجيست',
  'تجميل غير جراحي',
  'اخصائي تجميل غير جراحي',
  'أخصائي تجميل غير جراحي',
  // =========================
  // General / Seniority
  // =========================
  'manager',
  'general manager',
  'assistant manager',
  'branch manager',
  'area manager',
  'regional manager',
  'operations manager',
  'project manager',
  'product manager',
  'account manager',
  'key account manager',
  'office manager',
  'store manager',
  'restaurant manager',
  'sales manager',
  'marketing manager',
  'hr manager',
  'finance manager',
  'warehouse manager',
  'logistics manager',
  'procurement manager',
  'supply chain manager',
  'quality manager',
  'production manager',
  'maintenance manager',
  'it manager',
  'business development manager',

  'director',
  'head',
  'head of',
  'chief',
  'lead',
  'team lead',
  'leader',
  'senior',
  'junior',
  'entry level',
  'trainee',
  'intern',
  'graduate',
  'executive',
  'officer',
  'administrator',
  'admin',
  'assistant',
  'coordinator',
  'supervisor',
  'specialist',
  'consultant',
  'advisor',
  'representative',
  'agent',
  'associate',

  // =========================
  // Sales / Customer Service
  // =========================
  'sales',
  'sales representative',
  'sales executive',
  'sales specialist',
  'sales consultant',
  'sales associate',
  'sales supervisor',
  'sales coordinator',
  'indoor sales',
  'outdoor sales',
  'retail sales',
  'telesales',
  'tele sales',
  'call center',
  'call center agent',
  'customer service',
  'customer service agent',
  'customer service representative',
  'customer support',
  'support agent',
  'client relations',
  'client service',
  'account executive',
  'business development',
  'business developer',
  'bd executive',
  'commercial executive',
  'cashier',
  'store keeper',
  'shop assistant',

  // =========================
  // Marketing / Media / Creative
  // =========================
  'marketing',
  'marketing executive',
  'marketing specialist',
  'marketing coordinator',
  'digital marketing',
  'digital marketing specialist',
  'performance marketing',
  'media buyer',
  'seo specialist',
  'sem specialist',
  'social media',
  'social media specialist',
  'social media moderator',
  'social media manager',
  'content creator',
  'content writer',
  'copywriter',
  'creative copywriter',
  'community manager',
  'brand manager',
  'brand executive',
  'brand specialist',
  'public relations',
  'pr specialist',
  'photographer',
  'videographer',
  'video editor',
  'motion graphic designer',
  'motion designer',
  'graphic designer',
  'designer',
  'ui designer',
  'ux designer',
  'ui ux designer',
  'product designer',
  'visual designer',
  'art director',
  'creative director',
  '3d artist',
  'animator',
  'illustrator',

  // =========================
  // Tech / IT / Software
  // =========================
  'developer',
  'software developer',
  'software engineer',
  'frontend developer',
  'front end developer',
  'backend developer',
  'back end developer',
  'full stack developer',
  'fullstack developer',
  'web developer',
  'mobile developer',
  'android developer',
  'ios developer',
  'flutter developer',
  'react developer',
  'angular developer',
  'vue developer',
  'node js developer',
  'php developer',
  'laravel developer',
  'python developer',
  'java developer',
  'dotnet developer',
  '.net developer',
  'wordpress developer',
  'shopify developer',
  'programmer',
  'software programmer',
  'it specialist',
  'it support',
  'technical support',
  'help desk',
  'helpdesk',
  'system administrator',
  'network administrator',
  'network engineer',
  'cyber security',
  'security analyst',
  'devops engineer',
  'cloud engineer',
  'database administrator',
  'dba',
  'data analyst',
  'business analyst',
  'data engineer',
  'data scientist',
  'ai engineer',
  'machine learning engineer',
  'qa engineer',
  'quality assurance engineer',
  'software tester',
  'test engineer',
  'scrum master',
  'product owner',
  'erp consultant',
  'odoo developer',

  // =========================
  // Engineering / Construction
  // =========================
  'engineer',
  'civil engineer',
  'architect',
  'architect engineer',
  'architecture engineer',
  'mechanical engineer',
  'electrical engineer',
  'mechatronics engineer',
  'maintenance engineer',
  'production engineer',
  'planning engineer',
  'site engineer',
  'technical office engineer',
  'project engineer',
  'quality engineer',
  'qa qc engineer',
  'hse engineer',
  'safety engineer',
  'fire fighting engineer',
  'mep engineer',
  'hvac engineer',
  'design engineer',
  'cost control engineer',
  'estimation engineer',
  'procurement engineer',
  'sales engineer',
  'service engineer',
  'biomedical engineer',
  'chemical engineer',
  'agriculture engineer',
  'landscape engineer',
  'surveyor',
  'quantity surveyor',
  'draftsman',
  'autocad draftsman',
  'bim modeler',

  // =========================
  // Finance / Accounting
  // =========================
  'accountant',
  'general accountant',
  'senior accountant',
  'junior accountant',
  'cost accountant',
  'tax accountant',
  'payable accountant',
  'receivable accountant',
  'ar accountant',
  'ap accountant',
  'treasury accountant',
  'chief accountant',
  'finance',
  'finance officer',
  'finance specialist',
  'financial analyst',
  'financial controller',
  'auditor',
  'internal auditor',
  'external auditor',
  'bookkeeper',
  'payroll specialist',
  'payroll officer',
  'banking',
  'bank teller',
  'credit analyst',
  'collection officer',
  'collection specialist',

  // =========================
  // HR / Admin
  // =========================
  'hr',
  'human resources',
  'hr specialist',
  'hr generalist',
  'hr coordinator',
  'hr officer',
  'recruiter',
  'recruitment specialist',
  'talent acquisition',
  'personnel specialist',
  'payroll specialist',
  'training specialist',
  'learning and development',
  'organization development',
  'od specialist',
  'admin assistant',
  'administrative assistant',
  'executive assistant',
  'personal assistant',
  'secretary',
  'receptionist',
  'front desk',
  'office admin',
  'data entry',
  'document controller',

  // =========================
  // Logistics / Supply Chain / Warehouse
  // =========================
  'logistics',
  'logistics coordinator',
  'logistics specialist',
  'supply chain',
  'supply chain specialist',
  'procurement',
  'procurement specialist',
  'purchasing',
  'purchasing specialist',
  'buyer',
  'warehouse',
  'warehouse supervisor',
  'warehouse keeper',
  'storekeeper',
  'inventory controller',
  'inventory specialist',
  'fleet coordinator',
  'fleet supervisor',
  'delivery coordinator',
  'dispatcher',
  'shipping coordinator',
  'import specialist',
  'export specialist',
  'customs clearance',
  'planning specialist',

  // =========================
  // Medical / Pharma / Veterinary
  // =========================
  'doctor',
  'physician',
  'general practitioner',
  'dentist',
  'pharmacist',
  'clinical pharmacist',
  'nurse',
  'registered nurse',
  'head nurse',
  'medical representative',
  'medical rep',
  'medical sales representative',
  'veterinarian',
  'veterinary doctor',
  'vet',
  'vet assistant',
  'veterinary assistant',
  'lab technician',
  'laboratory technician',
  'radiology technician',
  'physiotherapist',
  'nutritionist',
  'dietitian',
  'beauty therapist',
  'dermatology assistant',

  // =========================
  // Food / Quality / Manufacturing
  // =========================
  'quality',
  'quality control',
  'quality assurance',
  'quality specialist',
  'quality inspector',
  'food safety',
  'food safety specialist',
  'haccp specialist',
  'iso specialist',
  'production',
  'production supervisor',
  'production specialist',
  'production planner',
  'manufacturing',
  'machine operator',
  'operator',
  'technician',
  'maintenance technician',
  'electrical technician',
  'mechanical technician',
  'lab technician',
  'qc inspector',
  'qa specialist',
  'safety officer',
  'hse officer',
  'hse specialist',

  // =========================
  // Hospitality / Restaurant / Tourism
  // =========================
  'chef',
  'head chef',
  'sous chef',
  'cook',
  'barista',
  'waiter',
  'waitress',
  'host',
  'hostess',
  'captain waiter',
  'restaurant supervisor',
  'restaurant captain',
  'kitchen supervisor',
  'housekeeping',
  'housekeeping supervisor',
  'front office',
  'front office agent',
  'reservation agent',
  'travel consultant',
  'tour operator',
  'tour guide',

  // =========================
  // Education
  // =========================
  'teacher',
  'english teacher',
  'math teacher',
  'science teacher',
  'arabic teacher',
  'french teacher',
  'instructor',
  'trainer',
  'teaching assistant',
  'academic coordinator',
  'education consultant',

  // =========================
  // Legal
  // =========================
  'lawyer',
  'legal advisor',
  'legal consultant',
  'legal specialist',
  'paralegal',

  // =========================
  // Arabic General / Seniority
  // =========================
  'مدير',
  'مدير عام',
  'مساعد مدير',
  'مدير فرع',
  'مدير منطقة',
  'مدير تشغيل',
  'مدير عمليات',
  'مدير مشروع',
  'مدير مشاريع',
  'مدير منتج',
  'مدير حسابات',
  'مدير مبيعات',
  'مدير تسويق',
  'مدير موارد بشرية',
  'مدير مالي',
  'مدير مخزن',
  'مدير مشتريات',
  'مدير لوجستيات',
  'مدير جودة',
  'مدير انتاج',
  'مدير صيانة',
  'مدير مطعم',
  'رئيس قسم',
  'قائد فريق',
  'مشرف',
  'مساعد',
  'منسق',
  'مسؤول',
  'اخصائي',
  'أخصائي',
  'إخصائي',
  'استشاري',
  'مستشار',
  'مندوب',
  'موظف',
  'تنفيذي',
  'متدرب',

  // =========================
  // Arabic Sales / Marketing / Customer Service
  // =========================
  'مبيعات',
  'مندوب مبيعات',
  'مسؤول مبيعات',
  'اخصائي مبيعات',
  'أخصائي مبيعات',
  'مشرف مبيعات',
  'منسق مبيعات',
  'مدير مبيعات',
  'مبيعات داخلية',
  'مبيعات خارجية',
  'تلي سيلز',
  'كول سنتر',
  'خدمة عملاء',
  'موظف خدمة عملاء',
  'ممثل خدمة عملاء',
  'دعم فني',
  'كاشير',
  'بائع',
  'مسؤول فرع',
  'تسويق',
  'مسوق',
  'اخصائي تسويق',
  'أخصائي تسويق',
  'تسويق رقمي',
  'ديجيتال ماركتنج',
  'سوشيال ميديا',
  'مسؤول سوشيال ميديا',
  'مودريتور',
  'ميديا باير',
  'كاتب محتوى',
  'صانع محتوى',
  'مصمم',
  'مصمم جرافيك',
  'مصمم موشن',
  'مونتير',
  'مصور',
  'مخرج فني',
  'تطوير اعمال',
  'تطوير أعمال',

  // =========================
  // Arabic Tech
  // =========================
  'مطور',
  'مبرمج',
  'مهندس برمجيات',
  'مطور ويب',
  'مطور مواقع',
  'مطور فرونت اند',
  'مطور باك اند',
  'مطور فل ستاك',
  'مطور موبايل',
  'مطور اندرويد',
  'مطور ايفون',
  'مطور فلاتر',
  'مطور لارافيل',
  'مطور وردبريس',
  'محلل بيانات',
  'مهندس بيانات',
  'عالم بيانات',
  'محلل اعمال',
  'محلل أعمال',
  'مهندس شبكات',
  'مسؤول شبكات',
  'دعم تقني',
  'دعم فني',
  'مسؤول نظم',
  'اختبار برمجيات',
  'مهندس اختبار',
  'ضمان جودة برمجيات',
  'امن سيبراني',
  'أمن سيبراني',

  // =========================
  // Arabic Engineering
  // =========================
  'مهندس',
  'مهندس مدني',
  'مهندس معماري',
  'مهندس ميكانيكا',
  'مهندس كهرباء',
  'مهندس ميكاترونكس',
  'مهندس انتاج',
  'مهندس إنتاج',
  'مهندس صيانة',
  'مهندس تخطيط',
  'مهندس موقع',
  'مهندس مكتب فني',
  'مهندس جودة',
  'مهندس سلامة',
  'مهندس مشتريات',
  'مهندس مبيعات',
  'مهندس تصميم',
  'مهندس تكلفة',
  'مهندس زراعي',
  'مهندس طبي',
  'رسام اوتوكاد',
  'مساح',
  'فني',
  'فني صيانة',
  'فني كهرباء',
  'فني ميكانيكا',
  'مشغل ماكينة',

  // =========================
  // Arabic Finance / HR / Admin
  // =========================
  'محاسب',
  'محاسب عام',
  'محاسب تكاليف',
  'محاسب ضرائب',
  'محاسب خزينة',
  'محاسب عملاء',
  'محاسب موردين',
  'رئيس حسابات',
  'مدقق حسابات',
  'مراجع حسابات',
  'محلل مالي',
  'مدير مالي',
  'امين خزينة',
  'أمين خزينة',
  'تحصيل',
  'موارد بشرية',
  'اخصائي موارد بشرية',
  'أخصائي موارد بشرية',
  'اتش ار',
  'HR',
  'مسؤول توظيف',
  'اخصائي توظيف',
  'أخصائي توظيف',
  'شؤون عاملين',
  'رواتب',
  'سكرتير',
  'سكرتيرة',
  'مساعد اداري',
  'مساعد إداري',
  'اداري',
  'إداري',
  'استقبال',
  'موظف استقبال',
  'مدخل بيانات',
  'مراقب مستندات',

  // =========================
  // Arabic Logistics / Medical / Food
  // =========================
  'مخازن',
  'امين مخزن',
  'أمين مخزن',
  'مسؤول مخزن',
  'مشرف مخزن',
  'لوجستيات',
  'منسق لوجستيات',
  'مشتريات',
  'اخصائي مشتريات',
  'أخصائي مشتريات',
  'مراقب مخزون',
  'مخلص جمركي',
  'استيراد',
  'تصدير',
  'طبيب',
  'طبيب عام',
  'طبيب اسنان',
  'طبيب أسنان',
  'صيدلي',
  'صيدلاني',
  'ممرض',
  'ممرضة',
  'تمريض',
  'مندوب طبي',
  'بيطري',
  'طبيب بيطري',
  'مساعد بيطري',
  'فني مختبر',
  'فني معمل',
  'اخصائي تغذية',
  'أخصائي تغذية',
  'جودة',
  'مراقب جودة',
  'ضمان جودة',
  'سلامة الغذاء',
  'اخصائي سلامة الغذاء',
  'أخصائي سلامة الغذاء',
  'انتاج',
  'إنتاج',
  'مشرف انتاج',
  'مشرف إنتاج',
  'سلامة وصحة مهنية',

  // =========================
  // Arabic Hospitality / Education / Legal
  // =========================
  'شيف',
  'طباخ',
  'باريستا',
  'ويتر',
  'نادل',
  'مشرف مطعم',
  'هاوس كيبنج',
  'حجز',
  'سياحة',
  'مدرس',
  'معلم',
  'معلمة',
  'مدرب',
  'محاضر',
  'مساعد تدريس',
  'محامي',
  'مستشار قانوني',
  'اخصائي قانوني',
  'أخصائي قانوني'
];

export const SMART_SEARCH_BAD_KEYWORDS: readonly string[] = [
  // =========================
  // File / CV labels
  // =========================
  'cv',
  'resume',
  'curriculum vitae',
  'bio data',
  'biodata',
  'profile',
  'personal profile',
  'personal information',
  'personal details',
  'personal data',
  'contact',
  'contact information',
  'contact details',
  'about me',
  'summary',
  'professional summary',
  'career summary',
  'objective',
  'career objective',
  'personal statement',

  // =========================
  // Contact / Social
  // =========================
  'email',
  'e-mail',
  'mail',
  'phone',
  'mobile',
  'telephone',
  'tel',
  'whatsapp',
  'address',
  'location',
  'nationality',
  'date of birth',
  'birth date',
  'dob',
  'marital status',
  'military status',
  'gender',
  'linkedin',
  'linked in',
  'github',
  'git hub',
  'portfolio',
  'behance',
  'website',
  'facebook',
  'instagram',
  'twitter',
  'x account',

  // =========================
  // CV Sections
  // =========================
  'education',
  'academic background',
  'qualification',
  'qualifications',
  'work experience',
  'professional experience',
  'employment history',
  'career history',
  'experience',
  'skills',
  'technical skills',
  'soft skills',
  'personal skills',
  'computer skills',
  'language skills',
  'languages',
  'certification',
  'certifications',
  'certificate',
  'certificates',
  'courses',
  'training',
  'trainings',
  'workshops',
  'projects',
  'personal projects',
  'achievements',
  'awards',
  'honors',
  'references',
  'reference',
  'interests',
  'hobbies',
  'activities',
  'volunteering',
  'volunteer work',
  'publications',
  'research',
  'licenses',
  'membership',
  'memberships',

  // =========================
  // Common CV table labels
  // =========================
  'name',
  'full name',
  'first name',
  'last name',
  'current position',
  'current employer',
  'company',
  'university',
  'college',
  'school',
  'faculty',
  'degree',
  'gpa',
  'grade',
  'graduation year',
  'from',
  'to',
  'present',
  'currently',
  'responsibilities',
  'duties',
  'tools',
  'software',
  'level',
  'beginner',
  'intermediate',
  'advanced',
  'native',
  'fluent',

  // =========================
  // Arabic CV labels
  // =========================
  'السيرة',
  'السيرة الذاتية',
  'سيرة ذاتية',
  'الملف الشخصي',
  'البيانات الشخصية',
  'بيانات شخصية',
  'المعلومات الشخصية',
  'معلومات شخصية',
  'نبذة',
  'نبذة شخصية',
  'نبذة مختصرة',
  'ملخص',
  'ملخص مهني',
  'الهدف',
  'الهدف الوظيفي',
  'عنّي',
  'عني',

  // =========================
  // Arabic Contact / Social
  // =========================
  'الاسم',
  'الاسم بالكامل',
  'الاسم الكامل',
  'الهاتف',
  'رقم الهاتف',
  'الموبايل',
  'رقم الموبايل',
  'الجوال',
  'رقم الجوال',
  'تليفون',
  'واتساب',
  'البريد',
  'البريد الإلكتروني',
  'الايميل',
  'الإيميل',
  'العنوان',
  'الموقع',
  'محل الإقامة',
  'محل الاقامة',
  'الجنسية',
  'تاريخ الميلاد',
  'الحالة الاجتماعية',
  'الموقف من التجنيد',
  'النوع',
  'لينكدإن',
  'لينكد ان',
  'جيت هاب',
  'بورتفوليو',
  'معرض الأعمال',
  'الموقع الإلكتروني',
  'فيسبوك',
  'انستجرام',

  // =========================
  // Arabic CV Sections
  // =========================
  'التعليم',
  'المؤهل',
  'المؤهلات',
  'المؤهل الدراسي',
  'الدراسة',
  'الجامعة',
  'الكلية',
  'المدرسة',
  'التقدير',
  'سنة التخرج',
  'الخبرة',
  'الخبرات',
  'الخبرات العملية',
  'الخبرة العملية',
  'الخبرة المهنية',
  'تاريخ العمل',
  'المهارات',
  'المهارات الفنية',
  'المهارات الشخصية',
  'مهارات الحاسب',
  'مهارات الكمبيوتر',
  'اللغات',
  'اللغة',
  'الشهادات',
  'الشهادة',
  'الدورات',
  'دورات تدريبية',
  'التدريب',
  'ورش العمل',
  'المشاريع',
  'المشروعات',
  'الإنجازات',
  'الانجازات',
  'الجوائز',
  'المراجع',
  'الهوايات',
  'الاهتمامات',
  'الأنشطة',
  'الانشطة',
  'العمل التطوعي',
  'التطوع',
  'الأبحاث',
  'الابحاث',
  'الرخص',
  'العضويات',

  // =========================
  // Arabic common labels
  // =========================
  'من',
  'إلى',
  'الى',
  'حتى الآن',
  'حتى الان',
  'حاليًا',
  'حاليا',
  'المسؤوليات',
  'المهام',
  'الأدوات',
  'الادوات',
  'البرامج',
  'المستوى',
  'مبتدئ',
  'متوسط',
  'متقدم',
  'بطلاقة'
];